import React from "react";
import {
  Grid,
  Box,
  Typography,
  TextField,
  IconButton,
  Stack,
  Link,
  Button,
  Tooltip,
  CardMedia,
} from "@mui/material";
import { LinkedIn, Facebook, Instagram, YouTube } from "@mui/icons-material";
import SendIcon from "@mui/icons-material/Send";
import Logo from "./Vertex Suite.png";
import metaLogo from "./metalogo.png";
import LinkdenImage from "./linkdin.png";
import InstagramImage from "./instagram.png";
import FbImage from "./facebook.png";
import YTImage from "./youtube.png";
import { useNavigate } from "react-router-dom";
import { MdEmail, MdLocationOn } from "react-icons/md";

const Footer = () => {
  const navigate = useNavigate();
  const handlePriceClick = () => {
    // navigate("/term-and-condition");
    navigate("/price");
  };

  const handleFAQClick = () => {
    // navigate("/term-and-condition");
    navigate("/faq");
  };

  const handleLogo = () => {
    navigate("/");
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100); // small delay ensures scroll happens after navigation
  };

  const handleTermClick = () => {
    // navigate("/term-and-condition");
    navigate("/policies", { state: { termCondition1: "true" } });
  };
  const handlePrivacyClick = () => {
    // navigate("/privacy-policy");
    navigate("/policies", { state: { privacyPolicy1: "true" } });
  };
  const handleRefundClick = () => {
    // navigate("/refund-policy");
    navigate("/policies", { state: { refundPloicy1: "true" } });
  };

  const handleNavigation = (path, parameter) => {
    if (parameter) {
      navigate(path, { state: { parameter } }); // Navigate with parameter
    } else {
      navigate(path); // Navigate without parameter
    }
  };

  const handleNavigation1 = (text) => {
    switch (text) {
      case "Pricing":
        navigate("/price");
        break;
      case "Help":
        navigate("/help");
        break;
      case "Features":
        navigate("/features");
        break;
      case "Marketing Partner":
        navigate("/marketing-partner");
        break;
      case "Affiliate Program":
        navigate("/affiliate");
        break;
      case "GDPR Compliance":
        navigate("/gdpr");
        break;
      case "Book a Demo":
        navigate("/book-demo");
        break;
      case "Contact Us":
        navigate("/contact-us");
        break;
      case "Security":
        navigate("/security");
        break;
      default:
        navigate("/");
    }
  };

  return (
    <Box position={"relative"}>
      <Box
        sx={{
          display: { xs: "none", md: "flex" },
          justifyContent: "center",
          marginBottom: { xs: "30px", md: "40px" },
          position: "relative",
          top: { xs: "-15px", md: "-20px" },
        }}
      >
        <Box
          sx={{
            position: "relative",
            background: "linear-gradient(to right, rgb(5, 78, 146), #4fc3f7)",
            padding: { xs: "8px 30px", md: "10px 50px" },
            fontSize: { xs: "1.2em", md: "1.5em" },
            fontWeight: "bold",
            borderRadius: "0 0 8px 8px",
            color: "#fff",
            zIndex: 10,
            "&::before": {
              content: '""',
              position: "absolute",
              top: "50%",
              left: "-15px" /* Adjusted to align with the left edge */,
              width: "30px",
              height: "30px",
              background:
                "rgb(5, 78, 146)" /* Matches the left gradient color */,
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: -1,
            },
            "&::after": {
              content: '""',
              position: "absolute",
              top: "50%",
              right: "-15px" /* Adjusted to align with the right edge */,
              width: "30px",
              height: "30px",
              background: "#4fc3f7" /* Matches the right gradient color */,
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: -1,
            },
          }}
        >
          <Typography
            variant="h5"
            component="span"
            sx={{
              fontSize: "20px",
              fontWeight: "bold",
              color: "#fff",
              fontStyle: "italic",
            }}
          >
            Inspired by Problems....
          </Typography>
        </Box>
      </Box>


      {/* FOOTER */}
      <Stack
        sx={{
          backgroundColor: {
            xl: "rgb(218 233 248)",
            lg: "rgb(218 233 248)",
            md: "rgb(218 233 248)",
            sm: "rgb(218 233 248)",
            xs: "none",
          },
          borderTopLeftRadius: "40px",
          borderTopRightRadius: "40px",

          // border: "1px solid red",
          zIndex: 10,
        }}
      >
        <Stack
          sx={{
            // border: "2px solid red",
            display: {
              lg: "flex",
              xl: "flex",
              md: "flex",
              sm: "flex",
              xs: "flex",
            },
            fontFamily: "'Roboto', sans-serif",
            flexDirection: {
              lg: "row",
              xl: "row",
              md: "row",
              sm: "column",
              xs: "column",
            },
            justifyContent: {
              lg: "center",
              xl: "center",
              md: "center",
              sm: "center",
              xs: "center",
            },
            alignItems: {
              lg: "center",
              xl: "center",
              md: "center",
              sm: "center",
              xs: "center",
            },
            paddingTop: {
              xl: "36px",
              lg: "36px",
              md: "36px",
              sm: "36px",
              xs: "0px",
            },
            borderTopLeftRadius: "40px",
            borderTopRightRadius: "40px",
            backgroundColor: "#FFFFFF",
          }}
        >
          <Box
            sx={{
              bgcolor: "background.paper",
              py: 6,
              px: { xs: 2, sm: 4, md: 8 },
              // borderTop: "1px solid #e0e0e0",
              position: "relative",
              bottom: 0,
              width: {
                lg: "100%",
                // xl: "78%",
                xl: "100%",
                md: "100%",
                sm: "100%",
                xs: "100%",
              },
              marginLeft: "10%",
            }}
          >
            <Grid
              container
              spacing={3}
              justifyContent="space-between"
            // sx={{ border: "1px solid red" }}
            >
              {/* Address Section */}

              <Grid
                item
                xs={12}
                md={3}
                sx={{
                  // border: "1px solid red",
                  display: {
                    xl: "block",
                    lg: "block",
                    md: "block",
                    sm: "none",
                    xs: "none",
                  },
                }}
              >
                <Stack
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    // width: "70%",
                    // marginBottom: "4px",
                    mt: -12,
                  }}
                  onClick={handleLogo}
                >
                  <img
                    src={Logo}
                    alt="logo"
                    style={{
                      height: "30%",
                      width: "30%",
                    }}
                  />
                </Stack>
                <Stack>
                  <Stack direction="row" spacing={2} mt={2}>
                    <img
                      src={FbImage}
                      alt="logo"
                      style={{ height: "30px", width: "30px" }}
                    />
                    <img
                      src={LinkdenImage}
                      alt="logo"
                      style={{ height: "30px", width: "30px" }}
                    />
                    <img
                      src={InstagramImage}
                      alt="logo"
                      style={{ height: "30px", width: "30px" }}
                    />
                    <img
                      src={YTImage}
                      alt="logo"
                      style={{ height: "30px", width: "30px" }}
                    />
                  </Stack>
                </Stack>

                <Stack
                  sx={{
                    color: "black",
                    // padding: "16px",
                    paddingTop: "18px",
                    borderRadius: "8px",
                    width: { xs: "100%", sm: "80%", md: "100%" },
                  }}
                  spacing={2}
                >
                  {/* Sales Email */}
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <MdEmail
                      style={{
                        fontSize: "16px",
                        lineHeight: "20px",
                        color: "#333",
                      }}
                    />
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: "bold",
                        fontFamily: "'Roboto', sans-serif",
                        color: "#333",
                      }}
                    >
                      info@atmikbharat.com
                    </Typography>
                  </Stack>
                  
                  {/*  */}
                  <Stack spacing={0.5}>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      {/* <MdLocationOn
                        style={{
                          fontSize: "16px",
                          lineHeight: "20px",
                          color: "#333",
                        }}
                      /> */}
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: "bold",
                          fontFamily: "'Roboto', sans-serif",
                          color: "#333",
                        }}
                      >
                        Atmik Bharat Industries Private Limited
                      </Typography>
                    </Stack>
                  </Stack>

                  {/* Registered Office */}
                  <Stack spacing={0.5}>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <MdLocationOn
                        style={{
                          fontSize: "16px",
                          lineHeight: "20px",
                          color: "#333",
                        }}
                      />
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: "bold",
                          fontFamily: "'Roboto', sans-serif",
                          color: "#333",
                        }}
                      >
                        Registered office address:
                      </Typography>
                    </Stack>
                    <Typography
                      variant="body2"
                      sx={{
                        // border: "1px solid red",
                        width: { xl: "70%" },
                        position: "relative",
                        left: { fontSize: "14px", lineHeight: "20px" },
                        fontFamily: "'Roboto', sans-serif",
                        color: "text.secondary",
                        marginLeft: "24px",
                      }}
                    >
                      R/O 18/10 Radhika Nagar, Supela, Bhilai -490023, Chhattisgarh
                    </Typography>
                  </Stack>

                  {/* Corporate Office */}
                  <Stack spacing={0.5}>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <MdLocationOn
                        style={{
                          fontSize: "16px",
                          lineHeight: "20px",
                          color: "#333",
                        }}
                      />
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: "bold",
                          fontFamily: "'Roboto', sans-serif",
                          color: "#333",
                        }}
                      >
                        Corporate office address:
                      </Typography>
                    </Stack>
                    <Typography
                      variant="body2"
                      sx={{
                        // border: "1px solid red",
                        width: { xl: "70%" },
                        position: "relative",
                        left: { fontSize: "14px", lineHeight: "20px" },
                        fontFamily: "'Roboto', sans-serif",
                        color: "text.secondary",
                        marginLeft: "24px",
                      }}
                    >
                      H.O. Block-86, Plot-2, Nehru Nagar East, Bhilai,
                      Chhattisgarh 490020
                    </Typography>
                  </Stack>
                </Stack>
              </Grid>

              <Grid
                item
                xs={12}
                md={3}
                sx={{
                  // border: "1px solid red",
                  display: {
                    xl: "none",
                    lg: "none",
                    md: "none",
                    sm: "block",
                    xs: "block",
                  },
                }}
              >
                <Stack
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    marginBottom: "8px",
                    // border: "1px solid green",
                    justifyContent: "space-between",
                  }}
                  onClick={handleLogo}
                >
                  <img
                    src={Logo}
                    alt="logo"
                    style={{ height: "52px", width: "52px" }}
                  />

                  <CardMedia
                    component="img"
                    image={metaLogo}
                    alt="title"
                    sx={{
                      height: "52px",
                      width: "38%",
                      border: "1px solid #ddd",
                      borderRadius: "4px",
                    }}
                  />
                </Stack>

                <Box mt={2}>
                  <Typography
                    variant="h6"
                    gutterBottom
                    sx={{
                      fontFamily: "'Roboto', sans-serif",
                      fontSize: "16px",
                      lineHeight: "24px",
                      fontWeight: 600,
                      color: "#333",
                    }}
                  >
                    Registered Address (India)
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontFamily: "'Roboto', sans-serif",
                      fontSize: "16px",
                      lineHeight: "22px",
                      fontWeight: 400,
                      color: "#757575",
                    }}
                  >
                    Atmik Bharat
                    <br />
                    H.O. Block-86, Plot-2,
                    <br />
                    Nehru Nagar East, Bhilai,
                    <br />
                    Chhattisgarh 490020
                  </Typography>
                </Box>
                <Box mt={2}>
                  <Link
                    to="/"
                    sx={{
                      textDecoration: "none",
                      "&:hover": {
                        textDecoration: "underline",
                        textDecorationColor: "black",
                      },
                    }}
                  >
                    <Typography
                      variant="body2"
                      color={"gray"}
                      sx={{
                        fontSize: "16px",
                        lineHeight: "24px",
                        fontWeight: 600,
                        fontFamily: "'Roboto', sans-serif",
                        color: "#757575",
                      }}
                    >
                      info@atmikbharat.com
                    </Typography>
                  </Link>
                </Box>
                <Stack>
                  <Typography
                    mt={2}
                    sx={{
                      fontFamily: "'Roboto', sans-serif",
                      fontSize: "16px",
                      lineHeight: "24px",
                      fontWeight: 600,
                      color: "#333",
                    }}
                  >
                    Find us online
                  </Typography>

                  <Stack direction="row" spacing={2} mt={2}>
                    <img
                      src={FbImage}
                      alt="logo"
                      style={{ height: "30px", width: "30px" }}
                    />
                    <img
                      src={LinkdenImage}
                      alt="logo"
                      style={{ height: "30px", width: "30px" }}
                    />
                    <img
                      src={InstagramImage}
                      alt="logo"
                      style={{ height: "30px", width: "30px" }}
                    />
                    <img
                      src={YTImage}
                      alt="logo"
                      style={{ height: "30px", width: "30px" }}
                    />
                  </Stack>
                </Stack>
              </Grid>

              {/* Links Section */}
              <Grid
                item
                xs={6}
                md={2}
                sx={{
                  // border: "1px solid red",
                  marginTop: {
                    lg: "0px",
                    xl: "0px",
                    md: "60px",
                    sm: "0px",
                    xs: "0px",
                  },
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: "20px",
                    lineHeight: "24px",
                    fontWeight: 700,
                    // color: "rgb(0, 0, 0)",
                    color: "rgb(5 78 146)",
                  }}
                  gutterBottom
                >
                  Home
                </Typography>
                {[
                  // "Pricing",
                  "Help",
                  "Features",
                  "Marketing Partner",
                  "Affiliate Program",
                  "GDPR Compliance",
                  "Book a Demo",
                  // "Contact Us",
                  "Security",
                ].map((text) => (
                  <Link
                    key={text}
                    // to="/"
                    onClick={() => handleNavigation1(text)}
                    sx={{
                      textDecoration: "none",
                      "&:hover": {
                        textDecoration: "underline",
                        textDecorationColor: "black",
                      },
                    }}
                  >
                    <Typography
                      variant="body2"
                      // color="rgb(71, 84, 103)"
                      sx={{
                        // border: "1px solid red",
                        marginBottom: {
                          lg: "4px",
                          sm: "4px",
                          md: "4px",
                        },

                        fontFamily: "'Roboto', sans-serif",
                        fontSize: {
                          xl: "16px",
                          lg: "16px",
                          sm: "16px",
                          xs: "16px",
                        },
                        lineHeight: "32px",
                        fontWeight: 400,
                        color: "rgb(71, 84, 103)",
                      }}
                    >
                      {text}
                    </Typography>
                  </Link>
                ))}
              </Grid>
              {/* Solution */}
              <Grid
                item
                xs={6}
                md={2}
                sx={{
                  // border: "1px solid red",
                  marginTop: {
                    lg: "0px",
                    xl: "0px",
                    md: "60px",
                    sm: "0px",
                    xs: "0px",
                  },
                }}
              >
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: "20px",
                    lineHeight: "24px",
                    fontWeight: 700,
                    // color: "rgb(0, 0, 0)",
                    color: "rgb(5 78 146)",
                  }}
                >
                  Solutions
                </Typography>
                {[
                  {
                    text: "Social Commerce",
                    path: "/",
                  },
                  {
                    text: "Communication & Marketing",
                    path: "/",
                  },
                  {
                    text: "Order & Inventory",
                    path: "/",
                  },
                  {
                    text: "Shipment & Warehousing",
                    path: "/",
                  },
                  {
                    text: "Multi Vendor",
                    path: "/",
                  },
                  {
                    text: "Analytics",
                    path: "/",
                  },
                  {
                    text: "Finance",
                    path: "/",
                  },
                ].map(({ text, path }, index) => (
                  <Link
                    key={index}
                    href={path}
                    sx={{
                      textDecoration: "none",
                      "&:hover": {
                        textDecoration: "underline",
                        textDecorationColor: "black",
                      },
                    }}
                  >
                    <Tooltip title="Coming Soon" arrow placement="left">
                      <Typography
                        variant="body2"
                        // color="rgb(71, 84, 103)"
                        sx={{
                          marginBottom: {
                            lg: "4px",
                            sm: "4px",
                            md: "4px",
                          },
                          fontFamily: "'Roboto', sans-serif",
                          fontSize: {
                            xl: "16px",
                            lg: "16px",
                            sm: "16px",
                            xs: "16px",
                          },
                          lineHeight: "32px",
                          fontWeight: 400,
                          color: "rgb(71, 84, 103)",
                        }}
                      >
                        {text || "Default text"}
                      </Typography>
                    </Tooltip>
                  </Link>
                ))}
              </Grid>
              {/* Useful links */}
              <Grid
                item
                xs={6}
                md={2}
                sx={{
                  // border: "1px solid red",
                  marginTop: {
                    lg: "0px",
                    xl: "0px",
                    md: "60px",
                    sm: "0px",
                    xs: "0px",
                  },
                }}
              >
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: "20px",
                    lineHeight: "24px",
                    fontWeight: 700,
                    // color: "rgb(0, 0, 0)",
                    color: "rgb(5 78 146)",
                  }}
                >
                  Useful Links
                </Typography>
                {[
                  {
                    text: "Integrations",
                    path: "/integration",
                    parameter: "true",
                  },
                  { text: "Blog", path: "/blog-component" },
                  { text: "Pricing", path: "/price" },
                  {
                    text: "Contact Us",
                    path: "/contact-us",
                    parameter: "true",
                  },
                  { text: "FAQ's", path: "/faq", parameter: "true" },
                  {
                    text: "Terms & Conditions",
                    path: "/policies",
                    parameter: "1",
                  },
                  {
                    text: "Privacy Policy",
                    path: "/policies",
                    parameter: "2",
                  },
                  {
                    text: "Refund Policy",
                    path: "/policies",
                    parameter: "3",
                  },
                ].map(({ text, path, parameter }, index) => (
                  <Link
                    key={index}
                    // href={path}
                    onClick={() => {
                      if (index === 5) {
                        handleTermClick();
                      } else if (index === 6) {
                        handlePrivacyClick();
                      } else if (index === 2) {
                        handlePriceClick();
                      } else if (index === 7) {
                        handleRefundClick();
                      } else if (text === "FAQ's") {
                        handleFAQClick(); // Trigger scroll for FAQ's
                      } else {
                        handleNavigation(path, parameter);
                      }
                    }}
                    sx={{
                      textDecoration: "none",
                      "&:hover": {
                        textDecoration: "underline",
                        textDecorationColor: "black",
                      },
                    }}
                  >
                    <Typography
                      variant="body2"
                      // color="rgb(71, 84, 103)"
                      sx={{
                        marginBottom: {
                          lg: "4px",
                          sm: "4px",
                          md: "4px",
                        },
                        fontFamily: "'Roboto', sans-serif",
                        fontSize: {
                          xl: "16px",
                          lg: "16px",
                          sm: "16px",
                          xs: "16px",
                        },
                        lineHeight: "32px",
                        fontWeight: 400,
                        color: "rgb(71, 84, 103)",
                      }}
                    >
                      {text || "Default text"}
                    </Typography>
                  </Link>
                ))}
              </Grid>
              {/* About us */}
              <Grid
                item
                xs={6}
                md={2}
                sx={{
                  // border: "1px solid red",
                  marginTop: {
                    lg: "0px",
                    xl: "0px",
                    md: "60px",
                    sm: "0px",
                    xs: "0px",
                  },
                }}
              >
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: "20px",
                    lineHeight: "24px",
                    fontWeight: 700,
                    // color: "rgb(0, 0, 0)",
                    color: "rgb(5 78 146)",
                  }}
                >
                  About
                </Typography>
                {[
                  {
                    text: "About Us",
                    path: "/about-us",
                  },
                  {
                    text: "Join Our Team",
                    path: "/about-us",
                  },
                  {
                    text: "Partners",
                    path: "/about-us",
                  },
                  {
                    text: "Events",
                    path: "/about-us",
                  },
                  {
                    text: "In The News",
                    path: "/about-us",
                  },
                  {
                    text: "Investments",
                    path: "/about-us",
                  },
                  { text: "Sitemap", path: "/site-map" },
                ].map(({ text, path }, index) => (
                  <a
                    key={index}
                    href={path}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      textDecoration: "none",
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        marginBottom: {
                          lg: "4px",
                          sm: "4px",
                          md: "4px",
                        },
                        fontFamily: "'Roboto', sans-serif",
                        fontSize: {
                          xl: "16px",
                          lg: "16px",
                          sm: "16px",
                          xs: "16px",
                        },
                        lineHeight: "32px",
                        fontWeight: 400,
                        color: "rgb(71, 84, 103)",
                        "&:hover": {
                          textDecoration: "underline",
                          textDecorationColor: "black",
                        },
                      }}
                    >
                      {text || "Default text"}
                    </Typography>
                  </a>
                ))}

                <Stack
                  sx={{
                    display: {
                      xl: "flex",
                      lg: "flex",
                      md: "flex",
                      sm: "flex",
                      xs: "none",
                    },
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    width: {
                      xl: "70%",
                      lg: "70%",
                      md: "70%",
                      sm: "70%",
                      xs: "90%",
                    },
                    marginBottom: "8px",
                    mt: 1.4
                    // border: "1px solid red",
                  }}
                  onClick={handleLogo}
                >
                  <img
                    src={metaLogo}
                    alt="logo"
                    style={{
                      height: "72px",
                      width: "80%",
                      border: "1px solid #ddd",
                      borderRadius: "4px",
                    }}
                  />
                </Stack>
              </Grid>
            </Grid>

            <Box
              mt={6}
              textAlign="center"
              sx={{
                borderTop: "1px solid #e0e0e0",
                display: "flex",
                flexDirection: {
                  xl: "row",
                  lg: "row",
                  md: "row",
                  sm: "column",
                  xs: "column",
                },
                justifyContent: {
                  xl: "space-between",
                  lg: "space-between",
                  md: "space-between",
                  sm: "center",
                  xs: "center",
                },
              }}
            >
              <Stack sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "15px",
                    lineHeight: "24px",
                    fontWeight: 600,
                    color: "text.secondary",
                    fontFamily: "'Roboto', sans-serif",
                    paddingTop: {
                      xl: "20px",
                      lg: "20px",
                      md: "20px",
                      sm: "20px",
                      xs: "20px",
                    },
                  }}
                >
                  Copyright © 2025 Atmik Bharat Industries Private Limited All
                  rights reserved.
                  {/* <span style={{ color: "text.secondary" }}>Copyright © 2025</span>{" "}
                  <span style={{ color: "rgb(5, 78, 146)" }}>
                    Atmik Bharat Industries Private Limited All rights reserved.
                  </span> */}
                </Typography>
              </Stack>
              <Stack
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                  // border: "1px solid red",
                }}
              >
                <Typography
                  variant="body2"
                  component="p"
                  sx={{
                    ffontSize: "15px",
                    lineHeight: "24px",
                    fontWeight: 600,
                    color: "text.secondary",
                    fontFamily: "'Roboto', sans-serif",

                    paddingTop: {
                      xl: "20px",
                      lg: "20px",
                      md: "20px",
                      sm: "20px",
                      xs: "4px",
                    },
                    marginBottom: {
                      xl: "0px",
                      lg: "0px",
                      md: "0px",
                      sm: "0px",
                      xs: "20px",
                    },
                  }}
                >
                  <span
                    onClick={() => handleTermClick()}
                    style={{
                      textDecoration: "none",
                      color: "inherit",
                      fontFamily: "'Roboto', sans-serif",
                      cursor: "pointer", // Ensure it looks like a clickable link
                      marginLeft: "8px",
                    }}
                  >
                    Terms of Service
                  </span>{" "}
                  |
                  <span
                    onClick={() => handlePrivacyClick()}
                    style={{
                      textDecoration: "none",
                      color: "inherit",
                      fontFamily: "'Roboto', sans-serif",
                      cursor: "pointer", // Ensure it looks like a clickable link
                      marginLeft: "8px",
                    }}
                  >
                    Privacy Policy
                  </span>{" "}
                  |
                  <span
                    onClick={() => handleRefundClick()}
                    style={{
                      textDecoration: "none",
                      color: "inherit",
                      fontFamily: "'Roboto', sans-serif",
                      cursor: "pointer", // Ensure it looks like a clickable link
                      marginLeft: "8px",
                    }}
                  >
                    Refund Policy
                  </span>
                </Typography>
              </Stack>
            </Box>
          </Box>
        </Stack>
      </Stack>
    </Box>
  );
};
export default Footer;
